import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';

import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { createChart, formatDate, formatYear } from 'src/app/shared/commen-function-file';
import { AssetDashboardDetailsComponent } from '../asset-dashboard-details/asset-dashboard-details.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-asset-dashboard',
  templateUrl: './asset-dashboard.component.html',
  styleUrls: ['./asset-dashboard.component.scss'],
})
export class AssetDashboardComponent implements OnInit {
  taskFromDateForAllGraph: any; 
  taskToDateForAllGraph: any
  selectGraphType: any = 'bar';
  dropdownSettings: IDropdownSettings = {};
  taskFromDate: any;
  taskToDate: any;
  selectedYearForAsset: any;
  currentYearSelected: any;
  loggedInUserName: any | null;
  subModuleButtonColor: any | null;
  buttonColorName: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  pmsYears: any = [];
  fromYear: any;
  toYear: any;

  selectedYearForDashboard: any;
  isAssetTypeIcon: any = 'bar';
  isApprovedByFinanceIcon: any = 'bar';
  isFinanceAmountPaidIcon: any = 'bar';
  isApprovedByPaidAmountIcon: any = 'bar';
  isAssetTypeTable: any = false;
  isAsseTableGraphOne: any = false;
  isApprovedByFinanceTable: any = false;
  isApprovedByPaidAmountTable: any = false;
  selectedFromDated: any;
  selectedtoDated: any;
  isswitchhowManyTimeRepairedAssetIcon: any = 'bar';
  isswitchhowManyTimeRepairedAssetTable: any = false;
  selectGraphThirdType: any = 'bar';
  isswitchhowManyDaysToAssignAssetIcon: any = 'bar';
  isswitchhowManyDaysToAssignAssetTable: any = false;
  selectGraphFourthType: any = 'bar';
  selectGraphTwoType: any = 'bar';
  reimbursementTypeTable: any;
  isRepairedByAssetIcon: any = 'bar';
  isRepairedByAssetTable: boolean = false;
  // findLogdinUserAsaAuthority :boolean = false;
  assetallData: any;
  totalassetCount: any = [];
  isAsseTableGraphTwo: any = [];
  selectedYearForAsset2: any;
  selectedYearForAsset3: any;
  selectedYearForAsset1: any;
  selectedYearForAsset4: any;
  findLogdinUserAsaAuthority: any = false;
  totalassetCountTop: any;
  constructor(public router: Router, private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, private activatedroute: ActivatedRoute, public sharedService: SharedService, public dialog: MatDialog,
    private fb: FormBuilder, private datePipe: DatePipe, private cdRef: ChangeDetectorRef, private PdfDownload: PdfDownloadService,
    public mobileResponsiveService:  MobileResponsiveService){

  }

  ngOnInit() {

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.findLogdinUserAsaAuthority = sessionStorage.getItem('findLogdinUserAsaAuthority');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.getpmsyearlist();





    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  processAllGraphDateRange() {

  }

  selectedYearForCompetency: any = null;

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
      this.getAllAssetData('bar')
      this.NewassetAllocationData();

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForAsset1 = selectedYearObj?.year;
      this.selectedYearForAsset2 = selectedYearObj?.year;
      this.selectedYearForAsset3 = selectedYearObj?.year;
      this.selectedYearForAsset4 = selectedYearObj?.year;
      // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getAllAssetData('bar')
      this.NewassetAllocationData();
      this.graphFirst(this.isAssetTypeIcon, 'first');
      setTimeout(() => {
        this.switchrepaiedAssetGraph(this.isRepairedByAssetIcon || 'bar');
      }, 100);
      
      this.isswitchhowManyTimeRepairedAssetIcon = this.isswitchhowManyTimeRepairedAssetIcon || 'bar';
      setTimeout(() => {
        this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon);
      }, 100);

    }
  }


  // Dashboard Year
  viewDashboardExpenseByYear(year: any) {
    console.warn("inside viewDashboardExpenseByYear " + year);
    this.selectedYearForDashboard = year;
    this.selectedYearForAsset = year;
    this.currentYearSelected = year

    this.selectGraphType = this.selectGraphType ? this.selectGraphType : 'bar';
    // this.getAllAssetData(this.reimbursementTypeCount, this.selectGraphType, this.selectedYearForDashboard, '', '');
    // this.getApprovedPaidAmountByCount(this.selectGraphType, this.selectedYearForDashboard, '', '');


  }


  
  viewAssetYear(year: any, graphNo: any) {
    this.taskFromDate = null;
    this.taskToDate = null;

    if (graphNo == 'first') {
      this.selectedYearForAsset1 = year
      this.graphFirst(this.isAssetTypeIcon, 'first')
    }
    else if (graphNo == 'second') {
      this.selectedYearForAsset2 = year;
      this.graphSecond(this.isRepairedByAssetIcon)
    } else if (graphNo == 'third') {
      this.selectedYearForAsset3 = year;
      this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon)
    }
    else if (graphNo == 'fourth') {
      this.selectedYearForAsset4 = year;
      this.graphFourth(this.isswitchhowManyDaysToAssignAssetIcon)
    }
    else if (graphNo == 'allDashBoard') {
      this.selectedYearForAsset1 = year;
      this.selectedYearForAsset2 = year;
      this.selectedYearForAsset3 = year;
      this.selectedYearForAsset4 = year;
      this.graphFirst(this.isAssetTypeIcon, 'allDashBoard');
      this.graphSecond(this.isRepairedByAssetIcon);
      setTimeout(() => {
        this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon);
      }, 100);
      // this.graphThird(this.isswitchhowManyTimeRepairedAssetIcon)
      this.graphFourth(this.isswitchhowManyDaysToAssignAssetIcon)
      this.NewassetAllocationData();
    } else { }
  }


  switchAssettypeGraph(graphType: any) {
    this.selectGraphType = graphType;

    this.isAssetTypeIcon = graphType;
    this.isAssetTypeTable = false;
    this.taskFromDate = null;
    this.taskToDate = null;
    this.graphFirst(this.selectGraphType, '');

  }

  switchReimbursementTypeTable() {
    this.selectGraphType = 'table';
    this.isAssetTypeIcon = '';
    this.isAssetTypeTable = true;

  }

  // Start For Second One
  switchrepaiedAssetGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isRepairedByAssetIcon = graphType;
    this.isRepairedByAssetTable = false;
    this.graphSecond(this.selectGraphTwoType);

  }
  switchrepaiedAssetGraphForTable() {
    this.selectGraphTwoType = 'table';
    this.isRepairedByAssetIcon = '';
    this.isRepairedByAssetTable = true;

  }

  switchhowManyTimeRepairedAsset(graphType: any) {
    this.selectGraphThirdType = graphType;
    this.isswitchhowManyTimeRepairedAssetIcon = graphType;
    this.isswitchhowManyTimeRepairedAssetTable = false;

    this.graphThird(graphType)
  }
  switchhowManyTimeRepairedAssetTable() {
    this.selectGraphThirdType = 'table';
    this.isswitchhowManyTimeRepairedAssetIcon = '';
    this.isswitchhowManyTimeRepairedAssetTable = true;
  }
  switchhowManyDaysToAssignAsset(graphType: any) {
    this.selectGraphFourthType = graphType;
    this.isswitchhowManyDaysToAssignAssetIcon = graphType;
    this.isswitchhowManyDaysToAssignAssetTable = false;
    this.graphFourth(this.selectGraphFourthType);
  }
  switchhowManyDaysToAssignAssetTable() {
    this.selectGraphThirdType = 'table';
    this.isswitchhowManyDaysToAssignAssetIcon = '';
    this.isswitchhowManyDaysToAssignAssetTable = true;
    // this.selectedYearForAsset4 = this.selectedYearForAsset;
  }
  getAllAssetData(graphType: any) {

    this.graphFirst(graphType, 'allDashBoard');
    this.graphSecond(graphType);
    this.graphThird(graphType);
    this.graphFourth(graphType);
    setTimeout(() => {
      this.NewassetAllocationData();
    }, 500)
  }
  passDataForDetailView: any;
  totalrepairedAsset: any;
  totalCountRecivedAsset: any;
  checkAuthority: any;
  currentlyRepairingAssets: Set<string> = new Set();// Used in tird graph
  assetNamesWithRepairedComment: Set<string> = new Set(); // Used in second graph


  graphFirst(graphType: any, Type: any) {

    setTimeout(() => { 

    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset1}`)
      .subscribe((response: any) => {
        console.log("iiiiiiiiiiiiii...........",);

        let dataForOnlyAuthority = response.data.filter((elm: any) => elm.authorityName == this.loggedInUserName && elm.userId != null);
        this.checkAuthority = dataForOnlyAuthority;

        let assetData: any = [];
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin') {
          assetData = response.data.filter((elm: any) => elm.userId != null);
        } else if (dataForOnlyAuthority && this.loggedInUserRole != 'HR Admin') {
          assetData = dataForOnlyAuthority
        }
        this.assetallData = assetData;

        // Create a set of asset names that are currently REPAIR_ASSET(for third graph remove count which not repaired asset)
        this.currentlyRepairingAssets = new Set(
          assetData
            .filter((item: any) => item.employeeAssetStatus === 'REPAIR_ASSET')
            .map((item: any) => item.assetName)
        );

        this.passDataForDetailView = assetData;
        let returnasset = assetData.filter((elm: any) => elm.authorityDepartmentComment == 'RECEIVED_AFTER_EXIT');
        let uniqueAssetNames = new Set(returnasset.map((item: any) => item.assetName));
        this.totalCountRecivedAsset = uniqueAssetNames.size;
        // this.totalCountRecivedAsset = returnasset.length;

        // Collect asset names with ASSET_REPAIRED for second graph filtering
        this.assetNamesWithRepairedComment = new Set(
          assetData
            .filter((elm: any) => elm.authorityDepartmentComment === 'ASSET_REPAIRED')
            .map((elm: any) => elm.assetName)
        );


        let assetCountArray: any = []
        assetData.map((record: any) => {
          if (!assetCountArray.some((elm: any) => elm.assetName == record.assetName)) {
            assetCountArray.push(record)
          }
        });


        this.totalassetCount = assetCountArray.length

        if (Type == 'allDashBoard') {
          this.totalassetCountTop = assetCountArray.length;
        }

        //for First graph

        console.log(this.assetallData);

        const transformedData: TransformedData = Object.values(
          this.assetallData.reduce((acc: any, item: any) => {
            const assetName = item.assetName;
            if (!acc[assetName]) {
              acc[assetName] = {
                xAxisValueData: assetName,
                seriesValueOneData: 0,
              };
            }
            acc[assetName].seriesValueOneData += 1;
            return acc;
          }, {})
        );

        console.log(this.isAsseTableGraphOne);

        this.isAsseTableGraphOne = transformedData;
        // Add metadata properties to the transformed data
        transformedData.xAxisName = 'Asset Name';
        transformedData.yAxisName = 'Employee Count';
        transformedData.seriesLabelOne = 'Count';
        transformedData.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };
        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedData, 'bar-line-chart-for-asset', 'single');
        }
      });

    }, 600);

  }
  // graphSecond(graphType: any) {
  //   this.httpService.callGetService(`${this.config.assetAllocationSecondGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset2}`)
  //     .subscribe((response: any) => {
  //       console.log("+++++++++++++++++++",response.data);

  //       let assetSecondGraphData = response.data.filter((elm: any) => elm.averageRepairDay !== 0.0);
  //       console.log(assetSecondGraphData);

  //       const transformedDataForRepaired: TransformedData = Object.values(
  //         assetSecondGraphData.reduce((acc: any, item: any) => {
  //           const assetName = item.assetName;

  //           if (!acc[assetName]) {
  //             acc[assetName] = {
  //               xAxisValueData: assetName,
  //               seriesValueOneData: 0,
  //             };
  //           }

  //           // Increment employee count for the asset
  //           acc[assetName].seriesValueOneData += item.averageRepairDay
  //             ? parseFloat(item.averageRepairDay) // Add repair time if it exists
  //             : 0;

  //           return acc;
  //         }, {})
  //       );



  //       this.isAsseTableGraphTwo = transformedDataForRepaired;


  //       // Add metadata properties to the transformed data
  //       transformedDataForRepaired.xAxisName = 'Asset Name';
  //       transformedDataForRepaired.yAxisName = 'Asset Repaired Day Count';
  //       transformedDataForRepaired.seriesLabelOne = 'Count';
  //       transformedDataForRepaired.seriesLabelTwo = '';
  //       // Dynamically render the graph based on graphType
  //       const graphFunctions: Record<string, Function> = {
  //         bar: this.assetBarGraph,
  //         line: this.assetLineGraph,
  //       };

  //       const renderGraph = graphFunctions[graphType];
  //       if (renderGraph) {
  //         renderGraph.call(this, transformedDataForRepaired, 'bar-line-repaired-chart', 'single');
  //       }
  //     })
  // }

  graphSecond(graphType: any) {
    setTimeout(() => { 
      
    this.httpService.callGetService(`${this.config.assetAllocationSecondGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset2}`)
      .subscribe((response: any) => {
        console.log("+++++++++++++++++++", response.data);

        let assetSecondGraphData = response.data;

        //  Apply authority-based filtering 
        const dataForOnlyAuthority = assetSecondGraphData.filter(
          (elm: any) => elm.authorityName === this.loggedInUserName
        );

        if (this.loggedInUserRole !== 'HR Admin' && this.loggedInUserRole !== 'Super Admin' && dataForOnlyAuthority.length > 0) {
          assetSecondGraphData = dataForOnlyAuthority;
        }

        //    original logic
        // assetSecondGraphData = assetSecondGraphData.filter((elm: any) => elm.averageRepairDay !== 0.0);
        // console.log(assetSecondGraphData);
        assetSecondGraphData = assetSecondGraphData.filter(
          (elm: any) =>
            elm.averageRepairDay !== 0.0 &&
            this.assetNamesWithRepairedComment.has(elm.assetName)
        );
        console.log("ghraph2222222.........",assetSecondGraphData);

        const transformedDataForRepaired: TransformedData = Object.values(
          assetSecondGraphData.reduce((acc: any, item: any) => {
            const assetName = item.assetName;

            if (!acc[assetName]) {
              acc[assetName] = {
                xAxisValueData: assetName,
                seriesValueOneData: 0,
              };
            }

            acc[assetName].seriesValueOneData += item.averageRepairDay
              ? parseFloat(item.averageRepairDay)
              : 0;

            return acc;
          }, {})
        );

        this.isAsseTableGraphTwo = transformedDataForRepaired;

        // Add metadata
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Repaired Day Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';

        // Render graph
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-repaired-chart', 'single');
        }
      });

    }, 600);
  }


  isAssetTableGraphThird: any = []
  repairedAssetCount: any = []
  graphThird(graphType: any) {
    this.httpService.callGetService(`${this.config.assetAllocationThirdGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset3}`)
      .subscribe((response: any) => {
        console.log("third graph 123......", response);

        let assetSecondThirdData: any = [];
        let repairedassetcount: any = [];
        let dataForOnlyAuthority = response.data.filter((elm: any) => elm.authorityName == this.loggedInUserName);
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin') {
          repairedassetcount = response.data;
        } else if (dataForOnlyAuthority.length > 0 && this.loggedInUserRole != 'HR Admin') {
          repairedassetcount = dataForOnlyAuthority
        }
        this.repairedAssetCount = repairedassetcount.filter((elm: any) => elm.statusChangeCount != 0);
        assetSecondThirdData = repairedassetcount;

        this.totalrepairedAsset = this.repairedAssetCount.length;
        console.log("aaaaa......", this.totalrepairedAsset);

        let transformedDataForRepaired = [];
        transformedDataForRepaired = assetSecondThirdData.map((item: any) => ({
          xAxisValueData: item.assetName,
          seriesValueOneData: item.statusChangeCount
        }));

        this.isAssetTableGraphThird = transformedDataForRepaired;
        // Add metadata properties to the transformed data
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Repaired Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-asset-repaired-chart', 'single');
        }
      })
  }



  // graphThird(graphType: any) {
    
  //   setTimeout(() => { 
  //   this.httpService.callGetService(`${this.config.assetAllocationThirdGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset3}`)
  //     .subscribe((response: any) => {
  //       console.log("third graph 123......", response);

  //       let assetSecondThirdData: any = [];
  //       let repairedassetcount: any = [];
  //       let dataForOnlyAuthority = response.data.filter((elm: any) => elm.authorityName == this.loggedInUserName);

  //       if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin') {
  //         repairedassetcount = response.data;
  //       } else if (dataForOnlyAuthority.length > 0 && this.loggedInUserRole != 'HR Admin') {
  //         repairedassetcount = dataForOnlyAuthority;
  //       }

  //       //  Filter only those assets which are STILL in REPAIR_ASSET status using assetallData from Graph 1
  //       const currentRepairingAssetNames = new Set(
  //         (this.assetallData || [])
  //           .filter((item: any) => item.employeeAssetStatus === 'REPAIR_ASSET')
  //           .map((item: any) => item.assetName)
  //       );

  //       // Filter graph data where asset is still in REPAIR_ASSET state
  //       const filteredGraphData = repairedassetcount.filter(
  //         (item: any) => currentRepairingAssetNames.has(item.assetName)
  //       );

  //       this.repairedAssetCount = filteredGraphData.filter((elm: any) => elm.statusChangeCount != 0);
  //       assetSecondThirdData = filteredGraphData;

  //       this.totalrepairedAsset = this.repairedAssetCount.length;
  //       console.log("aaaaa......", this.totalrepairedAsset);

  //       let transformedDataForRepaired = assetSecondThirdData.map((item: any) => ({
  //         xAxisValueData: item.assetName,
  //         // seriesValueOneData: item.statusChangeCount
  //         seriesValueOneData:  item.statusChangeCount
  //       }));

  //       this.isAssetTableGraphThird = transformedDataForRepaired;

  //       // Add metadata
  //       transformedDataForRepaired.xAxisName = 'Asset Name';
  //       transformedDataForRepaired.yAxisName = 'Asset Repaired Count';
  //       transformedDataForRepaired.seriesLabelOne = 'Count';
  //       transformedDataForRepaired.seriesLabelTwo = '';

  //       const graphFunctions: Record<string, Function> = {
  //         bar: this.assetBarGraph,
  //         line: this.assetLineGraph,
  //       };

  //       const renderGraph = graphFunctions[graphType];
  //       if (renderGraph) {
  //         renderGraph.call(this, transformedDataForRepaired, 'bar-line-asset-repaired-chart', 'single');
  //       }
  //     });

  //     }, 600);
  // }


  // --------------------fourth Graph ----------
  isAssetTableGraphFourth: any = []
  getListForAuthority: any = [];
  selectedAuthority: any = []
  graphFourth(graphType: any) {

    setTimeout(() => { 
    this.httpService.callGetService(`${this.config.assetAllocationFourthGraph}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
      .subscribe((response: any) => {

        let assetFourthGraphData: any = [];
        if (this.selectedAuthority.length > 0) {
          console.log("inside if");

          let authorityName = this.selectedAuthority.map((elm: any) => elm.name);


          assetFourthGraphData = response.data.filter((elm: any) => authorityName.includes(elm.authorityName));
        } else {
          console.log("inside else ");
          assetFourthGraphData = response.data;
        }
        let dataforDD = response.data;
        const emptyAuthorityData = (this.loggedInUserRole == 'Employee') ? dataforDD.filter((record: any) => record.userId == this.loggedInUserId) : dataforDD;

        this.getListForAuthority = [];
        let emptyAuthority: any = []
        emptyAuthorityData.forEach((ele: any, index: any) => {
          let obj = {
            id: index,
            name: ele.authorityName,
          }
          emptyAuthority.push(obj);

        });
        emptyAuthority.filter((elm: any) => {
          if (!this.getListForAuthority.some((record: any) => record.name == elm.name)) {
            this.getListForAuthority.push(elm)
          }
        })

        const GraphData = (this.loggedInUserRole == 'Employee') ? assetFourthGraphData.filter((record: any) => record.userId == this.loggedInUserId) : assetFourthGraphData;

        // Filter out entries where avgAllocatingDate === 0
        const transformedDataForRepaired = GraphData
          .filter((item: any) => item.avgAllocatingDate > 0)
          .map((item: any) => ({
            xAxisValueData: item.assetName,
            seriesValueOneData: item.avgAllocatingDate
          }));



        this.isAssetTableGraphFourth = transformedDataForRepaired;


        // Add metadata properties to the transformed data
        transformedDataForRepaired.xAxisName = 'Asset Name';
        transformedDataForRepaired.yAxisName = 'Asset Allocation Days Count';
        transformedDataForRepaired.seriesLabelOne = 'Count';
        transformedDataForRepaired.seriesLabelTwo = '';
        // Dynamically render the graph based on graphType
        const graphFunctions: Record<string, Function> = {
          bar: this.assetBarGraph,
          line: this.assetLineGraph,
        };

        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedDataForRepaired, 'bar-line-asset-allocatiom-chart', 'single');
        }
      });

    }, 600);
  }
  onSelectAuthority() {
    console.log(this.selectedAuthority);
    this.graphFourth(this.selectGraphFourthType);
  }
  onDelectAuthority() {
    this.graphFourth(this.selectGraphFourthType);
  }
  selectAllAuthority(event: any) {
    this.selectedAuthority = event;
    this.graphFourth(this.selectGraphFourthType);
  }
  onDeSelectAllAuthority() {
    this.selectedAuthority = [];
    this.graphFourth(this.selectGraphFourthType);
  }


  // Usage for Line Chart
  assetLineGraph(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  // Usage for Bar Chart
  assetBarGraph(data: any, idSelector: any, graphType: any): void {
    const chart = createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
    // this.mobileResponsiveService.chartResizeFn(chart);
  }

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }


  downloadChartAsPDF(type: any): void {


    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    const formattedFromDate = (this.selectedFromDated == undefined) ? '' : formatDate(this.selectedFromDated);
    const formattedtoDate = (this.selectedtoDated == undefined) ? '' : formatDate(this.selectedtoDated);
      
    if (type == 'Asset-Employee-Count') {
      var idSelector = (this.selectGraphType == 'table') ? 'asset-type-table-data' : 'bar-line-chart-for-asset';
      var selectedYearForAsset = this.selectedYearForAsset1;
      console.log("year...................",selectedYearForAsset);
      
    } else if (type == 'Asset Resolution') {
      var idSelector = (this.selectGraphTwoType == 'table') ? 'table-Asset-Resolution-data' : 'bar-line-repaired-chart';
      var selectedYearForAsset = this.selectedYearForAsset2;
    } else if (type == 'Asset Repaired Count') {
      var idSelector = (this.selectGraphThirdType == 'table') ? 'table-data-asset-repaired-count' : 'bar-line-asset-repaired-chart';
      var selectedYearForAsset = this.selectedYearForAsset3;
    } else {
      var idSelector = (this.selectGraphType == 'table') ? 'table-data-asset-allocatin-count' : 'bar-line-asset-allocatiom-chart';
      var selectedYearForAsset = this.selectedYearForAsset4;

    }

    let selectedYearForReimbursement;
    if (this.loggedInCompanyFiscalyear == "Jan_Dec") {
      let selectedYear = selectedYearForAsset;
      console.log(selectedYear);

      let year = selectedYear.split("-")[0];
      selectedYearForReimbursement = year;
    } else {
      selectedYearForReimbursement = this.selectedYearForAsset;

    }
    // Call the common function from the service
    this.PdfDownload.downloadPDF(
      idSelector, // chartId
      type, // Title
      selectedYearForAsset, // Year
      formattedFromDate, // From Date
      formattedtoDate // To Date
    );
  }
  newAllAssetListingData: any = []
  newAssetTotalLength: any = []
  newAssetData: any = [];
  AllAssetListingDataFromGetAPI: any = [];


  // NewassetAllocationData() {
  //   if (this.checkAuthority?.length > 0) {
  //     var arrAllAssetListingData:any = {};
  //     this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
  //       .subscribe((elm: any) => {
  //         const AllAssetListingData = elm.data;
  //         this.AllAssetListingDataFromGetAPI = AllAssetListingData; 

  //         const arrAllAssetData = (this.findLogdinUserAsaAuthority) ? AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId) :AllAssetListingData;

  //         arrAllAssetListingData = [...new Set(arrAllAssetData.flatMap((asset: any) => asset.bands))];

  //       });

  //     // this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInUserCompanyID}/${this.loggedInUserName}`)
  //     this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)

  //       .subscribe((elm: any) => {
  //           const newAssetData = elm.data;
  //           const newValue = (this.findLogdinUserAsaAuthority) ?  newAssetData.filter((asset: any) => arrAllAssetListingData.includes(asset.band)) : elm.data;

  //           let authorityData = newValue.filter((elm: any) =>
  //             elm.authorityName?.toLowerCase().trim() === this.loggedInUserName?.toLowerCase().trim()
  //           );

  //           if (authorityData.length === 0) {
  //             authorityData = newValue;
  //           }


  //         this.newAllAssetListingData = authorityData.flatMap((record: any) => record.unassignedAssets);
  //         this.newAssetData = authorityData;
  //         let empty: any = []
  //         this.newAllAssetListingData.filter((elm: any) => {
  //           if (!empty.some((record: any) => record == elm)) {
  //             empty.push(elm)
  //           }
  //         })


  //         this.newAssetTotalLength = []
  //         this.newAssetTotalLength = empty.length
  //       })
  //   } else {
  //     var arrAllAssetListingData:any = {};
  //     this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
  //       .subscribe((elm: any) => {
  //         const AllAssetListingData = elm.data;

  //         const arrAllAssetData = (this.findLogdinUserAsaAuthority=='true') ? AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId) :AllAssetListingData;

  //         arrAllAssetListingData = [...new Set(arrAllAssetData.flatMap((asset: any) => asset.bands))];

  //       });

  //     this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)
  //       .subscribe((elm: any) => {
  //         const newAssetData = elm.data;
  //         this.newAssetData = newAssetData;
  //         console.log("********************...............",  this.newAssetData);


  //         const newValue = (this.findLogdinUserAsaAuthority=='true') ?  newAssetData.filter((asset: any) => arrAllAssetListingData.includes(asset.band)) : elm.data;
  //         console.log("111111..........",newValue);

  //         this.newAllAssetListingData = newValue.flatMap((record: any) => record.unassignedAssets);
  //         console.log("22222222222", this.newAllAssetListingData);

  //         let empty: any = []
  //         this.newAllAssetListingData.filter((elm: any) => {
  //           if (!empty.some((record: any) => record == elm)) {
  //             empty.push(elm)
  //           }
  //         })
  //         console.log("44444...........",   this.newAllAssetListingData);

  //         this.newAssetTotalLength = []
  //         this.newAssetTotalLength = empty.length
  //         console.log("length is..........",   this.newAssetTotalLength);

  //       })
  //   }

  // }





  NewassetAllocationData() {
    if (this.checkAuthority?.length > 0) {
      let arrAllAssetListingData: any = [];

      this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
        .subscribe((elm: any) => {
          const AllAssetListingData = elm.data;
          console.log("dataaaaaaaaaaa==========", AllAssetListingData);

          this.AllAssetListingDataFromGetAPI = AllAssetListingData;

          console.log("66666.............", this.AllAssetListingDataFromGetAPI);

          //  Get only bands assigned to logged-in authority
          const authorityAssets = AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId);
          arrAllAssetListingData = [...new Set(authorityAssets.flatMap((asset: any) => asset.bands))];
          console.log("Authority Bands:", arrAllAssetListingData);


          //  fetch employees
          this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)
            .subscribe((elm: any) => {
              const newAssetData = elm.data;

              //  Filter employees in authority's bands, excluding self
              const filteredEmployees = newAssetData.filter((emp: any) =>
                arrAllAssetListingData.includes(emp.band) &&
                String(emp.userId) !== String(this.loggedInUserId)
              );

              //  Only  employees where authority name matches
              let authorityData = filteredEmployees.filter((emp: any) =>
                emp.authorityName?.toLowerCase().trim() === this.loggedInUserName?.toLowerCase().trim()
              );


              // If no exact authority match, fallback to all filtered band employees
              if (authorityData.length === 0) {
                authorityData = filteredEmployees;
              }
              console.log("Filtered Employees under Authority:", authorityData);

              // Only allow assets mapped to authority bands
              const allowedAssets = this.AllAssetListingDataFromGetAPI.filter(
                (asset: any) => asset.authorityName === this.loggedInUserName
              );

              const assetMapByBand = new Map<string, string[]>();
              allowedAssets.forEach((asset: any) => {
                asset.bands.forEach((band: string) => {
                  if (!assetMapByBand.has(band)) {
                    assetMapByBand.set(band, []);
                  }
                  assetMapByBand.get(band)!.push(asset.assetName);
                });
              });




              this.newAllAssetListingData = authorityData.flatMap((record: any) => {
                const allowedForBand = assetMapByBand.get(record.band) || [];
                return record.unassignedAssets?.filter((assetName: string) =>
                  allowedForBand.includes(assetName)
                ) || [];
              });

              this.newAssetData = authorityData;

              // Remove duplicates
              let uniqueAssets: any = [];
              this.newAllAssetListingData.forEach((elm: any) => {
                if (!uniqueAssets.includes(elm)) {
                  uniqueAssets.push(elm);
                }
              });




              this.newAssetTotalLength = uniqueAssets.length;
              console.log("Authority Asset Count BEFORE Allocation:", this.newAssetTotalLength);


            });
        });

    } else {
      // For non-authority or authority before allocation
      let arrAllAssetListingData: any = [];

      this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}`)
        .subscribe((elm: any) => {
          const AllAssetListingData = elm.data;
          this.AllAssetListingDataFromGetAPI = AllAssetListingData;

          // Filter bands only if authority
          const arrAllAssetData = (this.findLogdinUserAsaAuthority == 'true')
            ? AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId)
            : AllAssetListingData;

          arrAllAssetListingData = [...new Set(arrAllAssetData.flatMap((asset: any) => asset.bands))];

          // SECOND CALL for new employees
          this.httpService.callGetService(`${this.config.newJoiningEmployee}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForAsset4}/${this.loggedInUserCompanyID}`)
            .subscribe((elm: any) => {
              const newAssetData = elm.data;

              if (this.findLogdinUserAsaAuthority == 'true') {
                //  Filter employees by band and not self
                const filteredEmployees = newAssetData.filter((emp: any) =>
                  arrAllAssetListingData.includes(emp.band) &&
                  String(emp.userId) !== String(this.loggedInUserId)
                );

                //  Match employees by authority name
                let authorityData = filteredEmployees.filter((emp: any) =>
                  emp.authorityName?.toLowerCase().trim() === this.loggedInUserName?.toLowerCase().trim()
                );

                //  If no authority match, fallback to all band-filtered employees
                if (authorityData.length === 0) {
                  authorityData = filteredEmployees;
                }

                console.log("Filtered Employees under Authority:", authorityData);

                //  Restrict asset names by band
                const allowedAssets = this.AllAssetListingDataFromGetAPI.filter(
                  (asset: any) => asset.authorityName === this.loggedInUserName
                );

                const assetMapByBand = new Map<string, string[]>();
                allowedAssets.forEach((asset: any) => {
                  asset.bands.forEach((band: string) => {
                    if (!assetMapByBand.has(band)) {
                      assetMapByBand.set(band, []);
                    }
                    assetMapByBand.get(band)!.push(asset.assetName);
                  });
                });

                //  Final filtered unassigned assets
                this.newAllAssetListingData = authorityData.flatMap((record: any) => {
                  const allowedForBand = assetMapByBand.get(record.band) || [];
                  return record.unassignedAssets?.filter((assetName: string) =>
                    allowedForBand.includes(assetName)
                  ) || [];
                });

                this.newAssetData = authorityData;

                // Remove duplicates
                let uniqueAssets: any[] = [];
                this.newAllAssetListingData.forEach((elm: any) => {
                  if (!uniqueAssets.includes(elm)) {
                    uniqueAssets.push(elm);
                  }
                });

                this.newAssetTotalLength = uniqueAssets.length;
                console.log("Authority Asset Count BEFORE Allocation:", this.newAssetTotalLength);
              }

              //  Non-authority logic
              else {
                this.newAssetData = newAssetData;
                this.newAllAssetListingData = newAssetData.flatMap((record: any) => record.unassignedAssets || []);
                const unique = [...new Set(this.newAllAssetListingData)];
                this.newAssetTotalLength = unique.length;
              }
            });
        });
    }
  }




  onClickCard(event: any) {

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
     dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      allApiData: this.passDataForDetailView,
      loggdingUserId: this.loggedInUserId,
      repairedsset: this.repairedAssetCount,
      newAllAssetListingData: this.newAssetData,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false,
      allAuthorityAssets: this.AllAssetListingDataFromGetAPI,
      loggedinUserName: this.loggedInUserName,
    };
 
    // dialogConfig.panelClass = 'custom-dialog-container';
  const dialogRef = this.dialog.open(AssetDashboardDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });

  }

}
interface TransformedDataItem {
  xAxisValueData: string;
  seriesValueOneData: number;
}
interface TransformedData extends Array<TransformedDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
}

